import React from 'react'
import { useSelector } from 'react-redux'
import OnboardingTour from './OnboardingTour'
import ConfettiCongratsModal from './ConfettiCongratsModal'
import useOnboardingTour from 'hooks/useOnboardingTour'
import { hasCarPortalMinimalPermissionsSelector } from 'store/auth/userSlice'

const OnboardingTourProvider = ({ children }) => {
    const mediatorId = useSelector((state) => state.auth.user?.mediator_id)
    const isAuthenticated = useSelector((state) => state.auth.user !== null)
    const isCarPortal = useSelector((state) => state.auth.user?.is_car_portal || false)
    const hasMinimalPermissions = useSelector(
        hasCarPortalMinimalPermissionsSelector
    )
    const {
        isActive,
        currentStep,
        pendingStep,
        showCompletionModal,
        closeCompletionModal,
        startTour,
        stopTour,
        handleStepChange,
        handleComplete,
        handleSkip,
    } = useOnboardingTour()

    // Tour only for is_car_portal + mediator + car mediator with full authorized permission
    const showTour = isAuthenticated && mediatorId && isCarPortal && !hasMinimalPermissions
    return (
        <>
            {children}
            {showTour && (
                <OnboardingTour
                    isActive={isActive}
                    currentStep={currentStep}
                    pendingStep={pendingStep}
                    mediatorId={mediatorId}
                    onComplete={handleComplete}
                    onSkip={handleSkip}
                    onStepChange={handleStepChange}
                />
            )}
            {showCompletionModal && (
                <ConfettiCongratsModal onClose={closeCompletionModal} />
            )}
        </>
    )
}

export default OnboardingTourProvider
